
<style lang="less">

	.sv_container{
		position: relative;
	}

	.fixed-survey-header{
		z-index: 10;
		background-color: white;
		// top: 0;
		// left: 0;
		max-width: 951px;
		width: 100%;
		margin-top: 0px;

	}
	
	.sv-vue-row-additional-div{
		display: inline !important;
	}
	fieldset{
		border: 0px !important;
	}
	.cn-section-header {
		font-family: "Machina";
		font-size: 1.2em;
	}

	.cn-question-row{
		margin-bottom: 19px;
		display: flex !important;
		.cn-question-title{
			font-family: "work sans";
			font-size: 1.1em;
			h5{
				font-weight: normal !important;
			}

		}
	}

	.cn-text{
		width: 100%;
		padding: 12px 9px;
		background-color: white;
	}
	.cn-select-wrapper{
		position: relative; 
		clear: both;
		margin-bottom: 40px;
		background-color: white;
		width: 100%;
		height: 100%;
		.cn-select {
			width: 100%;
			padding: 12px 9px;
			z-index: 1;
			position: absolute;
			left: 0;
			top: 0;
		}
		width: 100%;
		&::after {
			font: normal normal normal 24px/1 "Material Design Icons";
			content: "\F004A";
			color: grey;
			position: absolute;
			top: 9px;
			right: 8px;
			margin-top: 2px;
			z-index: 0;
			margin-right: 2px;
		}
	}

	.cn-matrix-wrapper{
		width: 100%;
		table-layout: fixed;
		border-collapse: collapse;
		thead{
			display: none;
			font-family: "Machina"; 
			color: grey;
			th{
				padding-bottom: 10px;
				font-weight: 400;
				font-size: 0.9em;
				@media screen and (max-width: 700px) {
					font-size: 0.7em;
				}
			}
		}
		tr{
			border-bottom: 1px solid #ccc;
		}
		td{
			padding-bottom: 15px;
			padding-top: 15px;
			font-size: 0.8em;
			@media screen and (max-width: 700px) {
				font-size: 0.6em;
			}
			text-align: center;
			position: relative;	
			&.bg-primary {
				background-color:  #5568F1;
				color: white;
			}
			label.cn-matrix-question{
				padding: 20px 8px;
				height: 100%;
				width: 100%;
				display: block;
				&.checked {
					background-color:  #5568F1;
					&::after {
						font: normal normal normal 24px/1 "Material Design Icons";
						content: "\F05e0";
						color: white;
						width: 100%;
						text-align: center;
						z-index: 0;
						position: absolute;
						left: 0;
						top: 0;
						vertical-align: middle;
						padding-top: 6px;
						display: table-cell
					}
				}
				&.undefined {
					background-color:  #eee;
				}
				input {
					display: none;
				}
			}
			&:first-child{
				font-weight: bold;
				color: grey;
				width: 20% ;
				font-size: 0.8em;
				text-align: left !important;
			}
		}
	}
	.cn-radio-wrapper{
		display: contents !important;
		text-align: center !important;
		.cn-radio {
			display: inline-grid;
			// height: 100%;
			font-size: 0.7em;
			font-family: "Machina";
			padding: 5px;
			background-color: white;

				&.checked{
					label{						
						background-color: #5568F1 !important;
						color: white !important;
					}
				}
			label.v-card{
				width: 100%;
				padding-top: 23px;
				padding-bottom: 23px;
			}
			input{
				display: none !important;
			}
		}
	}
</style>
<template>
	<div class="mt-5">
		<v-dialog width="300px" v-model="warning_dialog">
			<v-card>
				<v-card-title>Sind Sie Sicher?</v-card-title>
				<v-card-text>Könnten Ihnen unsere Kollaborationsmodule bei der Antwortfindung helfen?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="warning_dialog = false">ok</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<survey :survey="surveyModel"></survey>
	</div>
</template>
<script>
	import * as SurveyVue from "survey-vue";
	import cnHeader from "@/assets/survey/cnHeader.js"
	SurveyVue.CustomWidgetCollection.Instance.addCustomWidget(cnHeader);
	SurveyVue.Serializer
    .addProperty("question", {
        name: "renderAs:text",
        default: 0,
        category: "general"
    });
	SurveyVue.Serializer
    .addProperty("question", {
        name: "cn_theme:text",
        default: 0,
        category: "general"
    });
	SurveyVue.Serializer
    .addProperty("question", {
        name: "cn_heading:text",
        default: 0,
        category: "general"
    });

	// import 'bootstrap-css-only/css/bootstrap.css';
	var Survey = SurveyVue.Survey
	// Survey.cssType = "bootstrap";
	import surveyCssClasses from "@/assets/survey/surveyCssClasses"
	export default {
		name: "CnRenderSurvey",
		props: {
			surveyContent: {type: Object },
			data: {type: Object }, 
			response: {type: Object }
		},
		data:() => {
			return {
				scrollPos: 0,
				warned: [],
				warning_dialog: false,
				surveyModel: {},
				css: surveyCssClasses
			}
		},
		components:{
			Survey: Survey
		},
		computed: {
			questionLength(){
				var obj = {
					total: 0
				}
				if( !this.surveyModel ){
					return obj
				}

				var questions = this.surveyModel.getAllQuestions();
				questions.forEach( q => { 
					if( q.rows ){
						if( !obj[q.cn_theme] ){
							obj[q.cn_theme] = 0;
						}
						if( !obj[q.cn_heading] ){
							obj[q.cn_heading] = 0;
						}
						var qs = q.rows.filter( a => a.isVisible).length
						obj.total += qs;
						obj[q.cn_theme] += qs;
						obj[q.cn_heading] += qs;
					}

				})
				return obj;
			},
			answeredLength(){
				var obj = {...this.questionLength}
				for(var key in obj ){
					obj[key] = 0;
				}
				if( !this.surveyModel.data ){
					return obj
				}
				var answers = this.surveyModel.getAllValues();
				for( var question in answers ){
					var as = Object.values(answers[question]).length;
					var q = this.surveyModel.getQuestionByName(question);
					if( q ){
						obj[q.cn_theme] += as;
						obj[q.cn_heading] += as;
					}
					obj.total += as;
				}
				return obj;
			},
			completionRate(){
				var obj = {
					total: 0
				}
				if( !this.surveyModel.data ){
					return obj
				}
				for( var key in this.questionLength ){
					obj[key] = Math.floor(this.answeredLength[key] / this.questionLength[key] * 100 )
				}
				return obj
			},
			currentQuestion(){
				if( !this.surveyModel.getAllQuestions ){
					return null;
				}
				var currentPos = this.scrollPos;
				var questionPos = {};
				var questions = this.surveyModel.getAllQuestions().filter( question => question.getType() == "matrix")
				var currentQuestion = questions[0];
				questions.filter( question => question.isVisible).forEach( question => {
					questionPos[question.id] = {
						pos: document.getElementById(question.id) ? document.getElementById(question.id).offsetTop : null,
						q: question
					}
				})
				Object.values(questionPos).forEach( q => {
					if( q.pos < currentPos ){
						currentQuestion = q.q; 
					}
				})
				window.currentHeader = currentQuestion.cn_heading;
				return currentQuestion;
			},
		},
		methods: {
			calculateScore(){
				var scores = {
					"Nicht-zutreffend": null, 
					"Gar-nicht": 0, 
					"Minimal": 25, 
					"Teilweise": 50, 
					"Weitgehend": 75,
					"Vollständig": 100 
				}
				var obj = {...this.questionLength}
				for(var key in obj ){
					obj[key] = [];
				}
				var answers = this.surveyModel.getAllValues();
				for( var question in answers ){
					var q = this.surveyModel.getQuestionByName(question);
					if( q ){
						for( var sub in answers[question]){	
							var answer = answers[question][sub];
							if( null !== scores[answer] ){								
								obj[q.cn_theme].push( answer )
								obj[q.cn_heading].push( answer )
								obj.total.push( answer )
							}			
						}
					}
				}
				var scored = {};
				for( key in obj ){
					scored[key] = obj[key].map( a => scores[a]  )
				}
				var averages = {}
				for( key in obj ){
					averages[key] = 0;
					if( scored[key].length ){
						averages[key] = this.average(scored[key])
					}
				}
				this.$store.dispatch("assessments/setScores", averages);
			}
		},
		watch: {
			currentQuestion(){
				this.$emit( "viewing", this.currentQuestion )
			},
			completionRate(){
				if( this.response ){
					this.calculateScore();
					this.$store.dispatch("assessments/updateResponse", {response_id: this.response.id, data: this.surveyModel.data, completion_rate: this.completionRate } )
				}
			},
			surveyContent: {
				immediate: true,
				handler(){
					const self = this;
					self.surveyContent.showTitle = false;
					self.surveyContent.showQuestionNumbers = "off";
					let SurveyModel = new SurveyVue.Model(self.surveyContent)
					window.S = SurveyModel;
					SurveyModel.completeText = "Nächster Schritt";
					self.surveyModel = SurveyModel;
					if( self.response ){
						SurveyModel.data = self.response.data;
					}
					SurveyModel.onComplete.add( () => {
						self.$router.push("/results")
					});
					SurveyModel.onValueChanged.add(function(survey, question){
						survey;
						if( Object.values(question.value).indexOf("ka") > -1 ){
							if( self.warned.indexOf( question.name ) < 0 ){
								self.warning_dialog = true;
								self.warned.push( question.name )
							}
						}
					})
					SurveyModel.css = self.css;					
				}
			},
			// response: {
			// 	immediate: true, 
			// 	handler() {
			// 		const self = this;
			// 		if( self.data ){
			// 			self.surveyModel.data = self.data;
			// 		}					
			// 	}
			// }
		},
		created: function() {
			var self = this;
			self.scrollPos = window.scrollY + 200;
			window.addEventListener('scroll', function() {
				self.scrollPos = window.scrollY + 200
			})
		}
	}
</script>